import clsx from 'clsx';
import { FC, useEffect, useState } from 'react';

import styles from './sign-in-page.module.scss';
import { ISignInPageProps } from './types';

import { SignIn } from '../../components';

import { getSignInBg } from '~utils';

export const SignInPage: FC<ISignInPageProps> = ({ className = '', ...rest }) => {
  const [bgImage, setBgImage] = useState<string | null>(null);

  useEffect(() => {
    getSignInBg()
      .then(res => {
        setBgImage(res.data?.link ?? null);
      })
      .catch(err => {
        console.log(err);
      });
  }, []);

  return (
    <section
      className={clsx(styles.container, className)}
      style={{ ...(bgImage && { backgroundImage: `url(${bgImage})` }) }}
      {...rest}
    >
      <SignIn className={styles.form} />
    </section>
  );
};
